import React from 'react';
import { Pie, PieChart, Tooltip, ResponsiveContainer, Cell, Legend } from 'recharts';

const Piechart = props => {
	const { data, dataKey, containerProps, chartProps, formatter } = props;
	const COLORS = ['#673ab7', '#ffeb3b', '#f44336', '#2196f3', '#795548'];
	return (
		<ResponsiveContainer width="100%" height="80%" aspect={4.0 / 3.2} {...containerProps}>
			<PieChart width={800} height={400} {...chartProps}>
				<Pie
					data={data}
					innerRadius={80}
					outerRadius={100}
					fill="#3f51b5"
					paddingAngle={5}
					dataKey={dataKey}
				>
					{data.map((entry, index) => (
						<Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
					))}
					<Legend />
				</Pie>
				<Tooltip formatter={value => (formatter ? `${value} ${formatter}` : value)} />
			</PieChart>
		</ResponsiveContainer>
	);
};

export default Piechart;
